import { useContext } from 'react';
import { GlobalSearchContext } from '../provider/GlobalSearchProvider';

export function useSearch() {
  const context = useContext(GlobalSearchContext);

  if (!context) {
    throw new Error('useSearch must be used within a GlobalSearchProvider');
  }

  return context;
}

export default useSearch;
